// extracted by mini-css-extract-plugin
module.exports = {"title":"h_j","chart-navigation":"h_k","chart-navigation__left":"h_l","chart-navigation__right":"h_m"};